import Vue from 'vue';
import store from 'store';
import Router from 'vue-router';
import Dashboard from './views/Dashboard.vue';
import Login from './views/Login.vue';
import SubAccounts from './views/SubAccounts.vue';
import Referrals from './views/Referrals.vue';
import Profile from './views/Profile.vue';
import AuthProvider from './utils/auth';
import i18n from './locales';

const authService = new AuthProvider();

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'login',
      },
    },
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        title: i18n.t('routeTitles.dashboard'),
        header: i18n.t('routeTitles.dashboard'),
        subHeader: i18n.t('subHeader.dashboard'),
        icon: 'pencil',
      },
    },
    {
      path: '/subaccounts',
      name: 'SubAccounts',
      component: SubAccounts,
      meta: {
        title: i18n.t('routeTitles.subAccounts'),
        header: 'subAccounts',
        subHeader: i18n.t('subHeader.subAccounts'),
        icon: 'users',
      },
    },
    {
      path: '/referrals',
      name: 'Referrals',
      component: Referrals,
      meta: {
        title: i18n.t('routeTitles.referrals'),
        header: 'referrals',
        subHeader: i18n.t('subHeader.referrals'),
        icon: 'hands-helping',
      },
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta: {
        title: i18n.t('routeTitles.profile'),
        header: i18n.t('routeTitles.profile'),
        subHeader: i18n.t('subHeader.profile'),
        icon: 'handshake',
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if ((!store.get('partner') && to.name !== 'Login') || (!authService.isAuthenticated() && to.name !== 'Login')) {
    next({
      name: 'Login',
      params: {
        routerFrom: 'Dashboard',
      },
    });
  } else if (authService.isAuthenticated() && to.name === 'Login') {
    next({
      name: 'Dashboard',
    });
  } else {
    if (to.meta.title) {
      document.title = `${to.meta.title} - Signable`;
    } else {
      document.title = 'Signable';
    }

    next();
  }
});

export default router;
